import Swiper from 'swiper/bundle'

//swiper
const swiper = new Swiper(".tvCalendar", {
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
        480: {
            slidesPerView: 1,
            spaceBetween: 1,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 1,
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 1,
        },
    }
})

function formatDate(date = new Date()) {
    const year = date.toLocaleString('default', {
        year: 'numeric'
    });
    const month = date.toLocaleString('default', {
        month: '2-digit',
    });
    const day = date.toLocaleString('default', {
        day: '2-digit'
    });

    return [year, month, day].join('-');

}

const swiper2 = new Swiper(".tvProg", {
    spaceBetween: 10,
    effect: 'fade',
    autoHeight: true,
    fadeEffect: {
        crossFade: true
    },
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
        /**
         * баг с скроллом календаря при клике на swiper-button-prev
         */
        slideChange: function() {
            swiper.slideTo(this.realIndex)
        },
        init: (e) => {
            /**
             * Выставляет свайпер в момент инициализации на нужный слайдер
             */
            let slides = e.slides
            const currentDate = formatDate(new Date())
            //const currentDate = "2023-11-08" //test

            for (let key in slides) {
                if (slides.hasOwnProperty(key)) {
                    let slide = slides[key]
                    let slideDate = slide.getAttribute('data-date')

                    console.log(`slide: ${key} currentDate`, currentDate)
                    console.log(`slide: ${key} slideDate`, slideDate)

                    const passedPrograms = slide.querySelectorAll('.is-passed');
                    const currentProgram = slide.querySelector('.is-current');
                    if (passedPrograms.length) {
                        const showPassedProgramsText = 'Показать прошедшие программы';
                        const hidePassedProgramsText = 'Скрыть прошедшие программы';
                        const showPassedBtn = document.createElement('button');
                        let isFull = false;
                        showPassedBtn.className = 'tvProg__btn';
                        showPassedBtn.innerText = showPassedProgramsText;
                        showPassedBtn.addEventListener('click', () => {
                            if (isFull) {
                                showPassedBtn.innerText = showPassedProgramsText;
                                slide.classList.remove('tvProg__list_full');
                            } else {
                                showPassedBtn.innerText = hidePassedProgramsText;
                                slide.classList.add('tvProg__list_full');
                            }
                            isFull = !isFull;
                        });
    
                        slide.insertAdjacentElement('afterbegin', showPassedBtn);
                    }

                    if (currentProgram) {
                        const programInfo = currentProgram.querySelector('.show__title');
                        const liveTag = document.createElement('div');
                        liveTag.className = 'tvProg__live';
                        liveTag.innerText = 'Сейчас в эфире';
                        programInfo.insertAdjacentElement('beforeend', liveTag);
                    }

                    if (slideDate == currentDate) {
                        e.slideTo(key)
                        break
                    }

                }
            }
        }
    }
});

//expandables
const triggers = Array.from(
    document.querySelectorAll('[data-toggle="collapse"]')
);
window.addEventListener(
    "click",
    (ev) => {
        const elm = ev.target;
        if (triggers.includes(elm)) {
            const selector = elm.getAttribute("data-target");
            collapse(selector, "toggle");
        }
    },
    false
);
const fnmap = {
    toggle: "toggle",
    show: "add",
    hide: "remove",
};
const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach((target) => {
        target.classList[fnmap[cmd]]("expand");
    });
};
var tggl = document.querySelectorAll(".clps");
for (let i = 0; i < tggl.length; i++) {
    tggl[i].addEventListener('click', textToggle)
}

function textToggle(e) {
    const el = e.target;
    if (el.getAttribute("data-text-swap") == el.innerHTML) {
        el.innerHTML = el.getAttribute("data-text-original");
    } else {
        el.setAttribute("data-text-original", el.innerHTML);
        el.innerHTML = el.getAttribute("data-text-swap");
    }
}



//end